module.exports = __webpack_public_path__ + "img/diesel-locomotive-shadow-08.ee579d42.png";